import { motion } from "framer-motion";

interface ApplyCtaProps {
  variant?: "light" | "dark";
  className?: string;
}

const ApplyCta = ({ variant = "light", className = "" }: ApplyCtaProps) => {
  const isDark = variant === "dark";

  const scrollToInversion = () => {
    const el = document.getElementById("inversion");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className={`text-center mt-12 ${className}`}
    >
      <button
        onClick={scrollToInversion}
        className={`inline-flex items-center gap-2 px-10 py-4 font-bold text-sm tracking-[0.15em] rounded-full transition-all duration-300 hover:scale-105 ${
          isDark
            ? "bg-[#7ab7fd] text-[#0a162a] shadow-lg shadow-[#7ab7fd]/30 hover:shadow-[0_12px_40px_rgba(122,183,253,0.5)] hover:bg-[#93c5fd]"
            : "bg-[#094399] text-white shadow-lg shadow-[#094399]/30 hover:shadow-[0_12px_40px_rgba(9,67,153,0.5)] hover:bg-[#0a4eb3]"
        }`}
      >
        APLICAR
      </button>
    </motion.div>
  );
};

export default ApplyCta;
